import type { ReactNode } from "react";
import { useState } from "react";
import { LoadingOverlayBackdrop } from "@/Shared/Components/CustomComponents/LoadingOverlayBackdrop";

// Full-screen blocking loading overlay for multi-step flows that call APIs
// between dialogs. Render `overlay` alongside the flow's dialogs.
export function useLoadingOverlay(): {
  setLoading: (isLoading: boolean) => void;
  overlay: ReactNode;
} {
  const [loading, setLoading] = useState(false);

  const overlay = loading && <LoadingOverlayBackdrop />;

  return { setLoading, overlay };
}
